<template>
  <div class="banner">
    <class-starting-banner v-if="showClassStartingBanner"></class-starting-banner>
    <missing-feedback-banner v-if="showMissingFeedbackBanner"></missing-feedback-banner>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import ClassStartingBanner from './ClassStartingBanner';
import MissingFeedbackBanner from './MissingFeedbackBanner';

export default {
  name: 'HeaderBanner',

  components: {
    ClassStartingBanner,
    MissingFeedbackBanner,
  },

  computed: {
    ...mapState('schedule', ['missingFeedbackClassesCount']),
    ...mapGetters(['userProfile', 'isAuthenticated']),
    ...mapGetters('schedule', ['tutorId', 'nearestAvailableClass']),

    availableClassStartingBannerRoutes() {
      return (
        this.$route.name === 'all_classes.class_detail' ||
        this.$route.name === 'my_schedule.class_detail' ||
        this.$route.name === 'my_schedule'
      );
    },

    availableMissingFeedbackBannerRoute() {
      return this.$route.name === 'my_schedule';
    },

    showMissingFeedbackBanner() {
      return (
        !!this.tutorId &&
        this.missingFeedbackClassesCount >= 1 &&
        this.availableMissingFeedbackBannerRoute &&
        !this.showClassStartingBanner
      );
    },

    showClassStartingBanner() {
      return (
        !!this.tutorId &&
        !!this.nearestAvailableClass &&
        this.availableClassStartingBannerRoutes &&
        this.isAuthenticated
      );
    },
  },
};
</script>

<style lang="scss">
.banner {
  position: relative;
  display: block;
}
</style>
